exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._43V2s3qddHrJhrifV--2zg\\=\\={-webkit-transform:scaleX(-1);transform:scaleX(-1)}", ""]);
// Exports
exports.locals = {
	"rtlIcon": "_43V2s3qddHrJhrifV--2zg=="
};